export const GET_MEMEBER_INFO_LOADING = 'REDUX_SAGA_GET_MEMEBER_INFO_LOADING';
export const POST_MEMBER_INFO_LOADING = 'REDUX_SAGA_POST_MEMBER_INFO_LOADING';
export const MEMBER_DATA_SUCCESS = 'REDUX_SAGA_MEMBER_DATA_SUCCESS';
export const MEMBER_DATA_ERROR = 'REDUX_SAGA_MEMBER_DATA_ERROR';

export const actionGetMemberInfo = (dispatch, getdata) => {
    dispatch({ type: GET_MEMEBER_INFO_LOADING, payload: getdata })
};

export const actionPostMemberInfo = (dispatch, postdata) => {
    dispatch({ type: POST_MEMBER_INFO_LOADING, payload: postdata })
};


//Didn't find its been used anywhere incode.